module.exports = __webpack_public_path__ + "img/cn-ico.830b62ef.png";